module.exports = __webpack_public_path__ + "b0346aa2348725e56ab84961f1531394.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/logos/brand-logo-microsoft.png
// module id = 635
// module chunks = 0